import React from "react";
import { useTranslation } from "react-i18next";
import { TextField, Typography } from "@mui/material";
import RequiredAsterisk from "./RequiredAsterisk";
import { Question, Questionnaire } from "./models";

const InputTextView = ({ question, questionnaire, onChange }: { question: Question, questionnaire: Questionnaire, onChange: (question: Question) => void }) => {
  const { t } = useTranslation(questionnaire.cohort);
  const labelText = t(question.question);
  const placeholderText = t(question.placeholder || "Enter text here");

  const handleOnChange = (value: string) => {
      question.value = value;
      onChange(question);
  };

  return (
    <div>
      <Typography variant="h6" component="div" style={{marginBottom: '0.5rem'}}>
        {labelText}
        {question.required && <RequiredAsterisk />}
      </Typography>
      <TextField
        label={placeholderText}
        placeholder={placeholderText}
        value={question.value}
        onChange={(e) => handleOnChange(e.target.value)}
        helperText={question.hint ? t(question.hint) : undefined}
      />
    </div>
  );
}

export default InputTextView;
